import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { IgButton, IgDialog, IgTypography } from "@intelligems/ig-theme";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { useArchiveCustomEvent } from "@src/api/custom-events/archive-custom-event";
import { isDialogOpen, setDialog } from "@src/store/slices/global";

export interface ArchiveCustomEventDialogProps {
  eventId: string;
}

export const ArchiveCustomEventDialog = ({
  eventId,
}: ArchiveCustomEventDialogProps) => {
  const dispatch = useDispatch();
  const archiveCustomEvent = useArchiveCustomEvent();
  const isOpen = useSelector(isDialogOpen("archiveCustomEvent"));

  const handleClose = () => {
    dispatch(setDialog({ dialog: "archiveCustomEvent", open: false }));
  };

  const handleArchive = () => {
    archiveCustomEvent.mutate({
      body: { customEventId: eventId },
      pathParams: undefined,
      queryParams: undefined,
    });
    handleClose();
  };

  return (
    <IgDialog
      showDialog={isOpen}
      handleClose={handleClose}
      rawContent={
        <IgTypography>
          Archiving this event will hide it form the list of trackable events
          when setting up a new experiment, helping you focus only on more
          relevant events.
          <br />
          <br /> It will continue to be tracked in any pending or active tests
          that already use it.
          <br />
          <br />
          You can always unarchive the event if you want to start using it
          again.
        </IgTypography>
      }
      title={"Archive Event?"}
      yesButtonText={"Yes, archive this event"}
      handleYesClick={handleArchive}
      handleNoClick={handleClose}
    />
  );
};
